import React, { ForwardedRef, forwardRef } from 'react';

import { TextInput } from '../../../TextInput';
import { cn } from '../../../../lib/css/className/className';
import './TagTextInput.css';

import { TagTextInputProps } from './types';

const cls = cn('TagTextInput');

export const TagTextInput = forwardRef(function TagTextInput(
    { tagGroupSize = 'm', ...textInputProps }: TagTextInputProps,
    ref: ForwardedRef<HTMLInputElement | HTMLTextAreaElement>,
) {
    return (
        <TextInput
            {...textInputProps}
            className={cls('', [textInputProps.className])}
            ref={ref}
            size={tagGroupSize}
            isTextarea
            sizeControlType={'auto'}
            restrictNewlines
        />
    );
});
